// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__10o2_","rulesModal":"Main_rulesModal__2YSU2","rulesModalCard":"Main_rulesModalCard__30TWF","closeModalIcon":"Main_closeModalIcon__2Eo-V"};